export default __webpack_public_path__ + "500c8efc924326997175105bdb8cb96b.png";